<soft-field-ok
  name="fahrzeug"
  placeholder="Name oder Nummer"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)"
>
</soft-field-ok>
